"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightRequestOrigin = void 0;
exports.FreightRequestOrigin = {
    API: 'API',
    SHIPWELL_WEBHOOK: 'SHIPWELL_WEBHOOK',
    INBOUNDS: 'INBOUNDS'
};
//# sourceMappingURL=freight-request-origin.js.map